/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import e from "prop-types";
const n = class n extends o.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
n.propTypes = {
  disabled: e.bool,
  contentClassName: e.string,
  children: e.oneOfType([
    e.element,
    e.node
  ]),
  title: e.oneOfType([
    e.string,
    e.element,
    e.node
  ])
};
let t = n;
export {
  t as TabStripTab
};
